const currentURL = window.location.hostname;
var domain = currentURL.split(".")[1];
var subdomain = currentURL.split(".")[0];
let version = "v2";

switch (subdomain) {
  case "localhost":
    subdomain = "demo";
    break;
  case "staging":
    subdomain = "demo";
    break;
  default:
    break;
}

if (domain === "vercel") {
  subdomain = "demo";
}

// export const baseUrl = `https://api-${subdomain}.everestbilling.com/api/${version}/`;
export const baseUrl = `https://everestbilling.com/api/${version}/`;

export const tenant = subdomain;
export const imgUrl = ``;
